import { ActionType } from './types';

export const showMessage = (type: 'SUCCESS' | 'ERROR' | 'WARNING', message: string) => ({
  type: ActionType.SNACKBAR_SHOW,
  payload: { type, message },
});
export const dismissMessage = () => ({ type: ActionType.SNACKBAR_DISMISS });
